<div class="main-content">
  <div class="main-heading">
    <span translate>MANUALS</span>
    <span class="page-actions text-right" *ngIf="isAdminMode">
      <button type="button" class="btn btn-success" (click)="newManual()">
        <span class="icon ic-sm icon-add"></span>
        <span translate>NEW_MANUAL</span>
      </button>
    </span>
  </div>
  <div class="card">
    <div class="card-body">
      <manual-tab
        *ngIf="isAdminMode"
        (onTabClick)="onTabClick($event)"
      ></manual-tab>
      <manual-list
        [manuals]="manuals"
        [manualType]="manualType"
        (onManualDelete)="onManualDelete($event)"
        (onManualEdit)="onManualEdit($event)"
      ></manual-list>
    </div>
  </div>
</div>

<p-dialog
  header="{{ newManualText | translate }}"
  *ngIf="showDialog"
  [(visible)]="showDialog"
  [style]="{ width: '500px', maxHeight: '85vh' }"
  [contentStyle]="{ overflowY: 'auto', paddingBottom: '1rem' }"
  [resizable]="true"
  [draggable]="false"
  (onHide)="onClose({ isSaved: false })"
>
  <manual-form
    #manualFormInstance
    [manual]="manual"
    [manualType]="manualType"
    (onClose)="onClose($event)"
    (buttonStateChange)="onManualFormButtonStateChange($event)"
  ></manual-form>

  <ng-template pTemplate="footer">
    <div class="action-btns-wrapper p-dialog-footer-buttons">
      <button
        type="button"
        (click)="triggerCancelClose()"
        class="btn btn-outline-secondary"
      >
        <span translate>CANCEL</span>
      </button>
      <button
        type="button"
        (click)="triggerSaveManual(true)"
        *ngIf="manualFormHideSaveAndContinue"
        [disabled]="!manualFormComponent?.createManualForm?.valid"
        class="btn btn-primary"
      >
        <span translate>SAVE_CONTINUE</span>
      </button>
      <button
        type="button"
        (click)="triggerSaveManual()"
        *ngIf="manualFormShowSaveAndClose"
        [disabled]="!manualFormComponent?.createManualForm?.valid"
        class="btn btn-primary"
      >
        <span translate>SAVE_AND_EXIT</span>
      </button>
    </div>
  </ng-template>
</p-dialog>

<toaster-component [toast]="toast"></toaster-component>
